var React = require('react');

function LinkedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41.589,41.6H34.36V30.272c0-2.7-.055-6.177-3.767-6.177-3.769,0-4.345,2.939-4.345,5.978V41.6H19.02V18.306h6.944v3.175h.094a7.618,7.618,0,0,1,6.855-3.763c7.324,0,8.679,4.821,8.679,11.1V41.6ZM10.855,15.119a4.2,4.2,0,1,1,4.2-4.2A4.194,4.194,0,0,1,10.855,15.119ZM14.48,41.6H7.231V18.306H14.48ZM45.206,0H3.6A3.559,3.559,0,0,0,0,3.517V45.3a3.558,3.558,0,0,0,3.6,3.517H45.2A3.571,3.571,0,0,0,48.816,45.3V3.517A3.573,3.573,0,0,0,45.2,0Z","fill":"#fff"}));
}

LinkedInline.defaultProps = {"width":"48.816","height":"48.816","viewBox":"0 0 48.816 48.816"};

module.exports = LinkedInline;

LinkedInline.default = LinkedInline;
